module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jVAnW"))).then(() => parcelRequire('37nVf'));